import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';
import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../components/TypewriterOnce';

type FirstJobIntroScreenProps = {
	onContinue: () => void;
};

export const FirstJobIntroScreen = ({
	onContinue,
}: FirstJobIntroScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h2
					className="mb-8"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="Before we talk strategy, let me kick off our first Job."
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<p
						className="mb-6"
						style={{
							fontSize: 18,
							lineHeight: 1.5,
							color: 'var(--text-primary)',
						}}
					>
						I&apos;ll discover businesses that are similar to you and watch
						what&apos;s working for them — the posts getting traction, the
						angles landing, the ideas we can borrow.
					</p>

					<p
						className="mb-10"
						style={{
							fontSize: 18,
							lineHeight: 1.5,
							color: 'var(--text-primary)',
						}}
					>
						It runs quietly in the background. You&apos;ll see what I find when
						something&apos;s worth your time.
					</p>

					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						onPress={onContinue}
					>
						<Text>Show me the Job</Text>
						<ChevronRight />
					</Button>
				</div>
			</div>
		</div>
	);
};
